import PropTypes from 'prop-types';
import Image from '../image/Image';
import styles from './success.module.less';

const Success = ({ success, img }) => {
    if (!success) {
        return null;
    }

    return (
        <div role="alert">
            <span className={styles.successModalMessage}>{success}</span>
            {img && <Image className={styles.successModalImg} role="presentation" src={img} alt="" />}
        </div>
    );
};

Success.propTypes = {
    success: PropTypes.string,
    img: PropTypes.string,
};

export default Success;
